import axiosHelper from '@/utils/axiosHelper'
import tableJS from '@/components/sys/Table'
import { Loading } from 'element-ui'

export default {
  // 显示用户表格栏目设置信息
  showTableColumnSet: async function (that, tableName) {
    const table = that[tableName]
    table.showColumnSetDialog = true
    table.changeShowColumnSetDialog = !table.changeShowColumnSetDialog
    table.ColumnSetLoading = true
    const tableStructure = await tableJS.getColumnInfo(table.tableCode)
    if (tableStructure.error === '000000') {
      table.userColumnInfo = tableStructure.columnInfo
      table.userTableInfo = tableStructure.tableInfo
    } else {
      that.$message.error(tableStructure.msg)
    }
    table.ColumnSetLoading = false
  },

  // 重置用户表格栏目设置信息
  resetTableColumnSet: async function (that, tableName) {
    const table = that[tableName]
    table.ColumnSetLoading = true
    const tableStructure = await tableJS.getColumnInfo(table.tableCode)
    if (tableStructure.error === '000000') {
      table.userColumnInfo = tableStructure.columnInfo
      table.userTableInfo = tableStructure.tableInfo
    } else {
      that.$message.error(tableStructure.msg)
    }
    table.ColumnSetLoading = false
  },

  // 保存用户栏目设置
  saveUserTableColumn: async function (that, tableName) {
    const table = that[tableName]
    const loadingInstance = Loading.service({ fullscreen: true })
    const rtnObj = await axiosHelper.handle('/WebSYSAction/Table.SaveTableUserColumnSettings', {
      columnsInfo: table.userColumnInfo,
      tableCode: table.tableCode,
      pageSize: table.userTableInfo.PageSize
    })
    if (rtnObj.error === '000000') {
      table.showColumnSetDialog = false
      table.changeShowColumnSetDialog = !table.changeShowColumnSetDialog
      that.$message.success('恭喜你，保存栏目设置成功！')
      tableJS.refreshTableStructure(that, tableName)
    } else {
      that.$message.error(rtnObj.msg)
    }
    loadingInstance.close()
  },

  // 把用户栏目恢复为默认设置
  returnDefaultTableColumn: async function (that, tableName) {
    that.$confirm('确定要恢复默认设置吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async () => {
      const table = that[tableName]
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/Table.SaveTableUserColumnSettings', {
        columnsInfo: [],
        tableCode: table.tableCode,
        pageSize: 50
      })
      if (rtnObj.error === '000000') {
        table.showColumnSetDialog = false
        table.changeShowColumnSetDialog = !table.changeShowColumnSetDialog
        that.$message.success('恭喜你，保存栏目设置成功！')
        tableJS.refreshTableStructure(that, tableName)
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    }).catch(() => {
    })
  }
}
